export default "/assets/site/images/tenisz.jpg?0f59aa2c2553dc2b619f42dbfa2f2f0a";